/**
 * Generic ajax form handling
 */
import Message from './Message';

export default class Form {
    constructor() {
        this.maxCharsInputs = $('[maxlength]');
        this.passwordMask = $('.password-mask-btn');
        this.setEventListeners();
    }

    setEventListeners() {
        // Show / Hide password
        this.passwordMask.on('click', (e) => this.togglePassword(e));

        // Max Character limit inputs
        this.maxCharsInputs.each((k, item) => this.createCharacterCounter($(item)));
        this.maxCharsInputs.on('keyup keydown', (e) => this.countCharacters(e));

        // Submit Form
        let self = this;
        $(document).on('submit', 'form.ajax', function(e) {
            self.showSpinner(e, $(this));
        });
    }

    /**
     * Create character count counter
     * @param target
     */
    createCharacterCounter(input) {
        let maxchars = input.attr('maxlength');
        let wrapper = $("<div></div>");
        let span = $("<span></span>");
        let value = input.val();
        if (value.length > maxchars) {
            value = value.substring(0, maxchars);
        }
        wrapper.addClass('max-length-wrapper');
        input.wrap(wrapper);
        span.addClass('count').insertAfter(input).html(value.length + "<span>/</span>"+maxchars);
    }

    /**
     * Update character count
     * @param e
     */
    countCharacters(e) {
        let input = $(e.currentTarget);
        let count = input.val().length;
        count = (count < 0) ? 0 : count;
        input.next('span').html(count+"<span>/</span>"+input.attr('maxlength'));
    }

    /**
     * Show / Hide the text of a password input
     * @param e
     */
    togglePassword(e) {
        let $inp = $(e.currentTarget).next('input');
        if ($inp.attr('type') === 'password') {
            $inp.attr('type', 'text');
            $(e.currentTarget).text('HIDE');
        } else {
            $inp.attr('type', 'password');
            $(e.currentTarget).text('SHOW');
        }
    }

    /**
     * Show the form spinner and submit the form
     * @param  {[type]} e    [description]
     * @param  {[type]} form [description]
     * @return {[type]}      [description]
     */
    showSpinner(e, frm) {
        e.preventDefault();
        let submitBtn = form.find('[type="submit"]');

        submitBtn.width(submitBtn.width()).height(submitBtn.height());

        if (submitBtn.is('button') ) {
            submitBtn.addClass('loading');
        }
        form.find('.submit-label').addClass('hide');
        form.find('.form-spinner').addClass('show');

        this.postForm(submitBtn, form);

        return false;
    }

    /**
     * Send the form to the backend
     * @param  {[type]} submitBtn [description]
     * @param  {[type]} form      [description]
     * @return {[type]}           [description]
     */
    postForm(submitBtn, form) {
        let self = this;
        $.ajax({
            url: form.attr('action'),
            method: form.attr('method'),
            data: form.serialize(),
            dataType: 'JSON',
            success: function(data) {
                let type = (data.success) ? 'success' : 'error';
                new Message(data.message, type);
            },
            error: function(data) {
                new Message(data.message, 'error');
            },
            complete: function(jqXHR, textStatus) {
                form.find('.submit-label').removeClass('hide').addClass('show');
                form.find('.form-spinner').removeClass('show').addClass('hide');
                submitBtn.removeClass('loading');
            }
        });
    }
}


// WEBPACK FOOTER //
// ./resources/assets/js/Form.js